import { AboutPage, AboutPageQuery } from '@/graphql/generated/graphql';

import { initializeApollo } from '../lib/apollo-client';
import requestHandler from '../requestHandler';
import { QUERY_ABOUT_PAGE } from '@/graphql/queries/about/about';

export const getPage = async () => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<AboutPageQuery>({
      query: QUERY_ABOUT_PAGE,
      fetchPolicy: 'cache-first',
    }),
  );

  return {
    page: data?.aboutPage?.data?.attributes as AboutPage,
    error,
  };
};
